import { Directive, ElementRef, HostListener, Renderer2 } from '@angular/core';

@Directive({
  selector: '[noNegative]'
})
export class NoNegativeDirective {

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const key = event.key;
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete', 'Tab'];
    const isModifierKey = event.altKey || event.ctrlKey || event.metaKey || event.shiftKey;
    if (isModifierKey || allowedKeys.includes(key)) {
      return;
    }
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;
    const position = input.selectionStart;
    if (key === '-' && position === 0 && !value.includes('-')) {
      return;
    }
    if (key === '-' || key === '.' || (key === '0' && value === '0') || isNaN(Number(key))) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event']) onInput(event) {
    const input = this.el.nativeElement as HTMLInputElement;
    const value = input.value;
    if (value.startsWith('-')) {
      this.renderer.setProperty(this.el.nativeElement, 'value', value.replace('-', ''));
    }
  }

}
